const FEATURES = {
  ACO: 'ACO',
  AdditionalVisit: 'Additional visit',
  Careteams: 'Careteams',
  CareHarmony: 'Care Harmony',
  DesktopAI: 'Desktop AI',
  Dragon: 'Dragon',
  Hospice: 'Hospice',
  InsuranceMapper: 'Insurance Mapper',
  MedrinaInvoicePCPs: 'Medrina Invoice PCPs',
  NeuroSuite: 'NeuroSuite',
  ONCDemographics: 'ONC Demographics',
  PlaceOfServiceOverride: 'Place of service override',
  POS32: 'POS 32 Backend Mapping',
  ProviderHold: 'Provider Hold',
  SuppressCPTSelection: 'Suppress CPT Selection',
  VisitNotesMIPS: 'VisitNotesMIPS',
  VisitNotesPOC: 'VisitNotes POC',
}

export default FEATURES
